const IMAGES = {
  SUN: require('./media/sun.svg').default,
  MOON: require('./media/moon.svg').default,
  AUTH_BG: require('./media/auth-bg.svg').default,
  SUN_DARK_MODE: require('./media/sun-dark-mode.svg').default,
  MOON_DARK_MODE: require('./media/moon-dark-mode.svg').default,
  LOCATION: require('./media/location-point.svg').default,
  PHONE: require('./media/phone.svg').default,
  MAIL: require('./media/mail.svg').default,
  FACEBOOK: require('./media/facebook.svg').default,
  ALERT_TRIANGLE: require('./media/alert-triangle.svg').default,
  BACK_ARROW: require('./media/back-arrow.svg').default,
  MENU_ICON: require('./media/menu-icon.svg').default,
  BANNER_MAIN: require('./media/bg-banner.png'),
  CIRCLE_BG: require('./media/circle-bg.svg').default,
  GREEN_BG: require('./media/green-bg.svg').default,
  LOCK: require('./media/lock.svg').default,
  USER: require('./media/user.svg').default,
  PHONE_LOGIN: require('./media/phone-login.svg').default,

  FLAG_VI: require('./media/vi.png'),
  FLAG_EN: require('./media/en.png'),
  MAIN_LOGO: require('./media/validus-logo.png'),
  GREEN_LOGO: require('./media/green-logo.png'),
  WHITE_LOGO: require('./media/logo-white.png'),
  FOOTER_LEFT: require('./media/footer-left-bg.png'),
  FOOTER_BG: require('./media/footer-bg.png'),
  FOOTER_RIGHT: require('./media/footer-right-bg.png'),
  INTRO_1: require('./media/intro-img-1.png'),
  INTRO_2: require('./media/intro-img-2.png'),
  INTRO_3: require('./media/intro-img-3.png'),
  JOURNEY: require('./media/journey.png'),
  THANKS: require('./media/thank-you.png'),
  VALUE1: require('./media/value1.png'),
  VALUE2: require('./media/value2.png'),
  VALUE3: require('./media/value3.png'),
  VALUE4: require('./media/value4.png'),
  KNOWLEDGE_LEFT: require('./media/knowledge-station.png'),
  KNOWLEDGE_LEFT1: require('./media/knowledge-left-1.png'),
  KNOWLEDGE_RIGHT: require('./media/img-station-knowledge.png'),
  CIRCLE_STATION: require('./media/station-circle.png'),
  VP_FLOWER: require('./media/vp-flower.png'),
  SALE_1: require('./media/sale1.png'),
  SALE_2: require('./media/sale2.png'),
  SALE_3: require('./media/sale3.png'),
  SALE_4: require('./media/sale4.png'),
  SALE_5: require('./media/sale5.png'),
  DIGITAL_LEFT: require('./media/cash-flow.png'),
  DIGITAL_RIGHT: require('./media/digital-right.png'),
  CASH_RIGHT: require('./media/cash-flow-right.png'),
  BUSINESS_LEFT: require('./media/business-left.png'),
  ECOMMERCE_LEFT: require('./media/ecommerce-left.png'),
  BUSINESS_RIGHT: require('./media/business-right.png'),
  MEMBER_PRIVILEGE1: require('./media/member1.png'),
  MEMBER_PRIVILEGE2: require('./media/member2.png'),
  MEMBER_PRIVILEGE3: require('./media/member3.png'),
  MEMBER_PRIVILEGE4: require('./media/member4.png'),
  FINANCE_LEFT: require('./media/finance-left.png'),
  FINANCE_LEFT1: require('./media/finance-left-1.png'),
  FINANCE_RIGHT: require('./media/finance-right.png'),
  EVENT_IMG: require('./media/event.png'),
  FINANCE_INTRO_1: require('./media/finance-intro-1.png'),
  FINANCE_INTRO_2: require('./media/finance-intro-2.png'),
  FINANCE_INTRO_3: require('./media/finance-intro-3.png'),
  BACKGROUND_LOGIN: require('./media/background-login.png'),
  BIG_HAND: require('./media/big-hand.png'),
  SUCCESS_REGISTER: require('./media/success-register.png'),
  EVENT_1: require('./media/event1.png'),
  UGLY_GIRL: require('./media/ugly-girl.png'),

  LOGO_LIGHT: require('./media/logo-light.png'),
  ICON_FOOTER: require('./media/icon-footer.png'),
  MARKER: require('./media/icon_white_marker.svg').default,
  PHONE_WHITE: require('./media/icon_white_phone.svg').default,
  FACEBOOK_WHITE: require('./media/icon_white_facebook.svg').default,
  MAIL_WHITE: require('./media/icon_white_mail.svg').default,
  SHIELD: require('./media/shield.svg').default,
  TEXT_BANNER: require('./media/text-banner.png'),
  VP_LOGO: require('./media/vp-logo.png'),
  CARE_LOGO: require('./media/care-logo.png'),
  BANNER_PERSON: require('./media/banner-person.png'),
  CASH_FLOW: require('./media/cash-flow.png'),
  WE07: require('./media/we07.png'),
  CASH_FLOW1: require('./media/qldt1.png'),
  CASH_FLOW2: require('./media/qldt2.png'),
  CASH_FLOW3: require('./media/qldt3.png'),
  CASH_FLOW4: require('./media/qldt4.png'),

  //COURSE
  COURSE_BACKGROUND: require('./media/bg-course.png'),
  COURSE_LOGO_VPBANK: require('./media/logo-vpbank-sme.png'),
  ICON_LOGOUT: require('./media/icon_logout.svg').default,
  MAINTAIN: require(`./media/maintain.png`),
}
export default IMAGES
